import {
  container,
  cardTitle,
  whiteColor,
  grayColor,
} from "assets/jss/material-dashboard-pro-react.js";


const loginPageStyle = (theme) => ({
  container: {
    ...container,
    zIndex: "4",
  },
  cardTitle: {
    ...cardTitle,
    color: whiteColor,
  },
  paddingFooterBottom: {
    textTransform:"unset",
    fontSize:"11px",
  },

  paddingFooterBottom2: {
    textTransform:"capitalize",
    marginBottom: 8,
    fontSize:"12px",
    width: "140px",
  },

  textCenter: {
    textAlign: "center",
  },
  customButtonClass: {
    "&,&:focus,&:hover": {
      color: whiteColor,
    },
    marginLeft: "5px",
    marginRight: "5px",
  },
  inputAdornment: {
    marginRight: "18px",
  },
  inputAdornmentIcon: {
    color: grayColor[6],
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)",
  },
  cardHeader: {
    marginBottom: "20px",
  },

  cardMap: {
    position: "absolute",
    top: "18%",
    right: "0",
    transform: "translate(0, -18%)",
    zIndex: "1100",
    marginRight: "1rem",
    width: "350px",
    height: "75vh",
  },
  cardLateralMap: {
    marginRight: "1rem",
    width: "350px",
    height: "calc(85vh - 260px)",
  },
  cardOverMap: {
    marginRight: "1rem",
    width: "350px",
    height: "265px",
  },
  cardBody: {
    paddingLeft: "0.3rem",
    paddingRight: "0.3rem",
  },
  mapLateralCloseButton: {
    position: "absolute",
    margin: "0",
    top: "0",
    left: "0",
    zIndex: "1080",
    transform: "translate(-50%, -50%)",
  },
});

export default loginPageStyle;
